import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLazyQueryNoCache } from 'Shared/Hooks/useApolloClient'
import { searchFilterUpdate } from 'Checkout/Redux/Actions/Search'
import sitesQuery from 'Checkout/Queries/SitesQuery'

export const useSitesQuery = () => {
  const dispatch = useDispatch()
  const { editingReservationId, reservations } = useSelector(state => state.cart)
  const currentSite = useSelector(state => state.search.site)
  const [getSites, { data, loading }] = useLazyQueryNoCache(sitesQuery)

  const sites = data?.campground?.sitesAvailableDuring?.map(site => site) || []
  const currentSiteSelected = sites.find(site => site.id === currentSite?.id)

  const buildExceptions = () => {
    const reservationsToBuild = reservations.filter(res => res.nanoId !== editingReservationId)

    return reservationsToBuild.map(({ data, from, to }) => ({
      from,
      rateId: data.rate.id,
      siteId: data.site?.id,
      to,
    }))
  }

  const handleGetRates = data => {
    const exceptions = buildExceptions()
    const variables = { ...data, exceptions }

    getSites({ variables })
  }

  useEffect(() => {
    if (editingReservationId && !loading) dispatch(searchFilterUpdate({ newSiteNeeded: !currentSiteSelected }))
  }, [currentSiteSelected?.id, sites.length])

  return [handleGetRates, { currentSiteSelected, loading, sites }]
}
